module.exports = __webpack_public_path__ + "static/img/logo.460d2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 96